import { Localize } from '../modules/utilities/localize';
class LoadExpired {
  constructor(node) {
    this.rootElement = node;
    this.expiredList = document.querySelector('.c-events-list__expired');

    this.rootElement.addEventListener('click', this.onClick.bind(this));
  }

  onClick() {
    if (this.expiredList.classList.contains('is-hidden')) {
      this.expiredList.classList.remove('is-hidden');
      this.rootElement.textContent = Localize('js.element.label.hide_expired_events.label', '');
    } else {
      this.expiredList.classList.add('is-hidden');
      this.rootElement.textContent = Localize('js.element.label.show_expired_events.label', '')
    }
  }
}

const expiredButtons = document.querySelectorAll('[data-show-expired-events]');
expiredButtons.forEach(expiredButton => {
  new LoadExpired(expiredButton);
});
